import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import './Login.scss';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      showErrorMessage: false,
      isSubmitting: false,
      cooldownSeconds: 0
    };

    this.handleLoginSubmission = this.handleLoginSubmission.bind(this);
    this.cooldownInterval = null;
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.loginFailure.message !== this.props.loginFailure.message ||
        prevProps.loginFailure.attempts !== this.props.loginFailure.attempts) &&
      this.props.loginFailure.message !== ''
    ) {
      this.setState({ showErrorMessage: true });

      const attempts = this.props.loginFailure.attempts || 0;
      if (attempts === 3) {
        this.startCooldown(10);
      } else if (attempts === 4) {
        this.startCooldown(20);
      } else if (attempts === 5) {
        this.startCooldown(30);
      } else if (attempts >= 6) {
        this.startCooldown(3600);
      }
    }
    if (
      prevProps.loginFailure.message !== this.props.loginFailure.message &&
      this.props.loginFailure.message === ''
    ) {
      this.setState({ showErrorMessage: false });
    }
  }

  componentWillUnmount() {
    this._unmounted = true;
    if (this.cooldownInterval) {
      clearInterval(this.cooldownInterval);
    }
  }

  startCooldown = seconds => {
    if (this.cooldownInterval) {
      clearInterval(this.cooldownInterval);
    }
    this.setState({ cooldownSeconds: seconds });
    this.cooldownInterval = setInterval(() => {
      this.setState(prev => {
        if (prev.cooldownSeconds <= 1) {
          clearInterval(this.cooldownInterval);
          this.cooldownInterval = null;
          return { cooldownSeconds: 0 };
        }
        return { cooldownSeconds: prev.cooldownSeconds - 1 };
      });
    }, 1000);
  };

  handleLoginSubmission = e => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ showErrorMessage: false, isSubmitting: true });
    Promise.resolve(
      this.props.submitLogin(
        this.state.username.trim().replace(/ /g, ''),
        this.state.password
      )
    ).finally(() => {
      if (!this._unmounted) {
        this.setState({ isSubmitting: false });
      }
    });
  };

  setUsername = e => {
    this.setState({ username: e.target.value });
  };

  setPassword = e => {
    this.setState({ password: e.target.value });
  };

  closeErrorMessage = e => {
    e.preventDefault();
    this.setState({ showErrorMessage: false });
  };

  render() {
    const props = this.props;
    const { isSubmitting, cooldownSeconds } = this.state;
    const isCoolingDown = cooldownSeconds > 0;
    return (
      <div className="text-center">
        <form className="form-signin" onSubmit={this.handleLoginSubmission}>
          <img
            className="mb-4"
            src="/assets/img/logo/logo_black.png"
            alt=""
            width="auto"
            height="72"
          />
          <h1 className="h3 mb-3 font-weight-normal">Sign in to Focus</h1>
          {this.state.showErrorMessage && (
            <div
              className="alert alert-danger alert-dismissible fade show"
              role="alert"
            >
              <strong>Login failed:</strong> {props.loginFailure.message}.
              {/* <span>[{3 - props.loginFailure.attempts} attempt(s) left]</span>. */}
              <button
                type="button"
                className="close"
                data-dismiss="alert"
                aria-label="Close"
                onClick={this.closeErrorMessage}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          )}
          <label htmlFor="userName" className="sr-only">
            Username
          </label>
          <input
            type="text"
            id="userName"
            className="form-control"
            placeholder="Username"
            autoComplete="username"
            required
            autoFocus={true}
            onChange={this.setUsername}
            disabled={isSubmitting}
          />
          <label htmlFor="inputPassword" className="sr-only">
            Password
          </label>
          <input
            type="password"
            id="inputPassword"
            className="form-control"
            placeholder="Password"
            autoComplete="current-password"
            required
            onChange={this.setPassword}
            disabled={isSubmitting}
          />

          {isCoolingDown && (
            <div className="alert alert-warning mt-2" role="alert">
              {cooldownSeconds > 60
                ? `For security reasons, your account is temporarily blocked. Please try again in ${Math.ceil(
                    cooldownSeconds / 60
                  )} minute(s).`
                : `For security reasons, please wait ${cooldownSeconds}s before trying again.`}
            </div>
          )}
          <button
            className="btn btn-lg btn-primary btn-block"
            type="submit"
            disabled={isSubmitting || isCoolingDown}
          >
            {isSubmitting ? 'Signing in...' : 'Sign in'}
          </button>
          <p className="mt-2">
            <a
              className="text-muted"
              href="https://sensingclues.freshdesk.com/support/home/"
            >
              Forgot Password?
            </a>
          </p>
          <p className="mt-4 mb-3 text-muted">
            &copy; {moment().format('YYYY')} |{' '}
            <a href="https://www.sensingclues.nl/">Sensing Clues website</a>
          </p>
        </form>
      </div>
    );
  }
}

Login.propTypes = {
  submitLogin: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  loginFailure: PropTypes.object
};

export default Login;
